(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('decorium-announcements')) {
    customElements.define('decorium-announcements', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.track = this.querySelector('[data-track]');
        this.items = [...this.querySelectorAll('[data-item]')];
        this.status = this.querySelector('[data-status]');
        this.mobile = matchMedia('(max-width: 989px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        if (!this.track || !this.items.length) return;
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        if (previous && next) {
          previous.hidden = false;
          next.hidden = false;
          previous.addEventListener('click', () => this.go((this.targetIndex ?? this.index) - 1), { signal });
          next.addEventListener('click', () => this.go((this.targetIndex ?? this.index) + 1), { signal });
        }
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        }, { passive: true, signal });
        this.track.addEventListener('scrollend', () => { this.targetIndex = null; this.sync(); }, { signal });
        this.track.addEventListener('pointerdown', () => { this.targetIndex = null; }, { signal });
        this.track.addEventListener('wheel', () => { this.targetIndex = null; }, { passive: true, signal });
        this.track.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || event.altKey || event.ctrlKey || event.metaKey) return;
          let index;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight') index = (this.targetIndex ?? this.index) + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') index = (this.targetIndex ?? this.index) + (rtl ? 1 : -1);
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.items.length - 1;
          if (index !== undefined) { event.preventDefault(); this.go(index); }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.items.indexOf(event.target.closest('[data-item]'));
          if (index >= 0) this.go(index, true);
        }, { signal });
        this.resize = new ResizeObserver(() => {
          if (this.mobile.matches) this.go(this.index, true, false);
          else this.track.scrollTo({ left: 0, behavior: 'instant' });
          this.sync();
        });
        this.resize.observe(this.track);
        this.sync();
      }
      go(index, instant = false, announce = true) {
        if (!this.mobile.matches) return;
        this.index = (index + this.items.length) % this.items.length;
        this.targetIndex = this.index;
        const item = this.items[this.index];
        if (this.items.some(slide => slide !== item && slide.contains(document.activeElement))) this.track.focus({ preventScroll: true });
        const left = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left: this.track.scrollLeft + left, behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth' });
        if (announce && this.status) this.status.textContent = `${this.index + 1} / ${this.items.length}: ${item.innerText.trim()}`;
      }
      sync() {
        if (this.mobile.matches) {
          const left = this.track.getBoundingClientRect().left;
          let distance = Infinity;
          this.items.forEach((item, index) => {
            const current = Math.abs(item.getBoundingClientRect().left - left);
            if (current < distance) { distance = current; this.index = index; }
          });
        }
        this.items.forEach((item, index) => {
          item.inert = this.mobile.matches && index !== this.index;
        });
        this.track.tabIndex = this.mobile.matches && this.items.length > 1 ? 0 : -1;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
